import { useLanguage } from "@/context/LanguageContext";
import { content, FOOD_PASTA } from "@/content/fitswag";
import { StoreButtons } from "@/components/StoreButtons";
import Reveal from "@/components/Reveal";

export default function DownloadCTA() {
  const { lang } = useLanguage();
  const t = content[lang].download;

  return (
    <section id="download" className="relative overflow-hidden border-t border-white/10 bg-black">
      <div className="absolute inset-0">
        <img src={FOOD_PASTA} alt="" className="h-full w-full object-cover object-center opacity-30" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/85 to-black/70" />
      </div>

      <div className="relative mx-auto max-w-4xl px-5 py-28 text-center md:px-8 md:py-36">
        <Reveal>
          <p className="overline text-brand-orange">{t.overline}</p>
          <h2 className="mt-4 font-display text-5xl leading-[0.98] tracking-tighter text-white sm:text-6xl md:text-7xl">
            {t.title}
          </h2>
          <p className="mx-auto mt-6 max-w-xl text-lg leading-relaxed text-white/70">{t.subtitle}</p>
          <div className="mt-10 flex justify-center">
            <StoreButtons
              primary={t.ctaPrimary}
              secondary={t.ctaSecondary}
              testPrefix="download"
              onDownload={() => document.getElementById("download")?.scrollIntoView({ behavior: "smooth" })}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
